const urlUtils = require('utils/Url');

/**
 *
 * @param method
 * @param url
 * @param body
 * @param params -
 * @param qsParams - array of nvps to be converted in to the querystring.  If multiple querystring
 * entries are needed for the same key, then the nvp should contain:  'key': [arrayOfValues]
 * @param headers
 * @param isMultiPart
 * @returns {{then, catch}}
 */
function request({
    method,
    url,
    params = {},
    qsParams = {},
    headers = {},
    isMultiPart = false
}) {
    let body;

    if (!url) {
        throw new Error('Url argument is required!');
    }

    if (!method) {
        throw new Error('Method argument is required!');
    }

    if (method === 'POST') {
        if (isMultiPart || typeof params === 'string') {
            body = params;
        } else {
            body = JSON.stringify(params);
        }
    }

    if (Object.keys(qsParams).length) {
        url += '?' + urlUtils.makeQueryString(qsParams);
    }

    return fetch(url, {
        method, body, headers
    });
}


/**
 * API -> state mapping error handler
 * @param {*} error 
 */
let handleApiResponseMappingError = (error) => {
    /*eslint no-console: "off"*/
    console.error(`API RESPONSE -> STATE MAPPING ERROR: ${error}`);
};


/**
 * throws an error
 */
let throwApiError = (obj, path) => {
    throw `API RESPONSE -> STATE MAPPING ERROR
        RESPONSE: ${JSON.stringify(obj)}
        REQUESTED PATH: "${path}"`;
};


/**
 * returns true if property is named, and exist in an object
 * @param {*} obj 
 * @param {*} propName 
 */
let propExist = (obj, propName) => 
    obj instanceof Object && 
    propName !== '' && 
    propName in obj;


/**
 * finds if the prop of defined depth exists and returns it or throws an error
 * @param {*} rootObj parnt object for path prop search
 * @param {*} pathToVal path for search
 */
let getValOrThrowError = (rootObj, pathToVal) =>
    pathToVal
        .split('.')
        .reduce((obj, propName) => 
            propExist(obj, propName) ? obj[propName] : throwApiError(rootObj, pathToVal), rootObj);


/**
 * returns if the prop of defined depth exists or throws an error
 * @param {*} obj 
 * @param {*} path 
 */
let isValOrThrowError = (obj, path) => !!getValOrThrowError(obj, path);


module.exports = {
    request,
    handleApiResponseMappingError,
    getVal: getValOrThrowError,
    isVal: isValOrThrowError
};
